import React from "react";
import { Select, Dropdown, SelectProps, MenuProps } from "antd";


interface StyledDropdownProps extends SelectProps {
  dropdownType?: "select" | "menu";
  items?: MenuProps["items"];
  onSelectMenu?: (key: string) => void;
  children?: React.ReactNode;
}

const StyledDropdown: React.FC<StyledDropdownProps> = ({
  dropdownType = "select",
  items,
  onSelectMenu,
  children,
  ...props
}) => {
  if (dropdownType === "menu" && items && onSelectMenu) {
    const menu = {
      items,
      onClick: ({ key }: { key: string }) => onSelectMenu(key),
    };

    return (
      <Dropdown
        menu={menu}
        trigger={["click"]}
        overlayClassName="custom-dropdown-menu"
      >
        {children}
      </Dropdown>
    );
  }

  // Default to select dropdown
  const isMulti = props.mode === "multiple" || props.mode === "tags";
  const maxTagCount = props.maxTagCount ?? (isMulti ? 2 : undefined);
  const maxTagPlaceholder =
    props.maxTagPlaceholder ?? ((omitted: unknown[]) => `+${omitted.length}`);
  const suffixIcon =
    props.suffixIcon ?? <span className="styled-dropdown-caret" aria-hidden="true" />;
  const hasValue =
    props.value !== undefined &&
    props.value !== null &&
    (Array.isArray(props.value) ? props.value.length > 0 : props.value !== "");

  return (
    <Select
      {...props}
      popupClassName={props.popupClassName || "custom-dropdown-menu"}
      getPopupContainer={
        props.getPopupContainer ||
        (triggerNode => triggerNode?.ownerDocument?.body || document.body)
      }
      suffixIcon={suffixIcon}
      maxTagCount={maxTagCount}
      maxTagPlaceholder={maxTagPlaceholder}
      className={`custom-dropdown ${hasValue ? "custom-dropdown--has-value" : ""} ${props.className || ""}`}
    />
  );
};

export default StyledDropdown;
